<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Atualização Cadastral' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>

  <div class="div-imagem-extendido">
    <img [src]="pessoa.foto | image:' '" class="image-extendido" />
  </div>

  <h2 class="nome-pessoa bold-2">{{pessoa.nome}}</h2>

  <div>
    <form class="sample-form validations-form" [formGroup]="validations_form">
      <ion-grid style="border-bottom: 1px solid #e3e3e3">
        <ion-row>
          <ion-col class="remove-border">
            <ion-list>
              <ion-item>
                <ion-select
                  interface="action-sheet"
                  interface="popover"
                  labelPlacement="stacked"
                  label="Status de Recadastramento"
                  (ionChange)="changeStatus($event)"
                  formControlName="codigo2"
                >
                  <ion-select-option
                    *ngFor="let status of statusList"
                    [value]="status.id"
                  >
                    {{status.nome}}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-list>
              <ion-item lines="none">
                <ion-label class="title-per"
                  >{{'Editar Dados' | translate}}</ion-label
                >
              </ion-item>

              <ng-container>
                <ion-item>
                  <ion-input
                    type="text"
                    class="custom"
                    labelPlacement="stacked"
                    formControlName="nome"
                    placeholder="{{'Nome' | translate}}"
                  >
                    <div slot="label" class="slot-label">
                      {{'Digite seu nome' | translate}}<ion-text
                        color="danger"
                        *ngIf="tipo === '6' || tipo === '1'"
                        >*</ion-text
                      >
                    </div>
                  </ion-input>
                </ion-item>

                <div
                  class="validation-errors"
                  *ngIf="tipo === '6' || tipo === '1'"
                >
                  <ng-container
                    *ngFor="let validation of validation_messages.nome"
                  >
                    <div
                      class="error-message"
                      *ngIf="validations_form.get('nome')?.hasError(validation.type) && (validations_form.get('nome')?.dirty || validations_form.get('nome')?.touched)"
                    >
                      {{ validation.message }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container>
                <ion-item class="input-tel">
                  <div class="input-tel">
                    <ion-label>
                      {{'CPF' | translate}}<ion-text
                        color="danger"
                        *ngIf="tipo === '6'"
                        >*</ion-text
                      >
                    </ion-label>

                    <input
                      class="native-input"
                      type="tel"
                      formControlName="cpf"
                      mask="000.000.000-00"
                      placeholder="{{ 'Digite seu CPF' | translate }}"
                    />
                  </div>
                </ion-item>

                <div class="validation-errors" *ngIf="tipo === '6'">
                  <ng-container
                    *ngFor="let validation of validation_messages.cpf"
                  >
                    <div
                      class="error-message"
                      *ngIf="validations_form.get('cpf')?.hasError(validation.type) && (validations_form.get('cpf')?.dirty || validations_form.get('cpf')?.touched)"
                    >
                      {{ validation.message }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container>
                <prover-datepicker
                  [labelName]="'Data de Nascimento'"
                  [id]="'data'"
                  [(dateTime)]="pessoa.nascimento"
                  formControlName="nascimento"
                  [required]="tipo === '6' || tipo === '1'"
                  [isDataAtual]="true"
                ></prover-datepicker>

                <div
                  class="validation-errors"
                  *ngIf="tipo === '6' || tipo === '1'"
                >
                  <ng-container
                    *ngFor="let validation of validation_messages.nascimento"
                  >
                    <div
                      class="error-message"
                      *ngIf="validations_form.get('nascimento')?.hasError(validation.type) && (validations_form.get('nascimento')?.dirty || validations_form.get('nascimento')?.touched)"
                    >
                      {{ validation.message }}
                    </div>
                  </ng-container>
                </div>

                <ion-item-divider></ion-item-divider>
              </ng-container>

              <ng-container>
                <ion-item>
                  <div class="input-tel">
                    <ion-label>
                      {{ "Celular" | translate }}<ion-text
                        color="danger"
                        *ngIf="tipo === '6'"
                        >*</ion-text
                      >
                    </ion-label>

                    <input
                      type="tel"
                      formControlName="telCelular"
                      phoneIntl="phoneCelular"
                      [ddiTarget]="pessoa.contato?.ddiTelCelular || '+55'"
                      [maskMap]="maskMap"
                      [mask]="maskMap.get('phoneCelular')"
                      [showFlag]="false"
                      placeholder="{{ 'Digite seu celular' | translate }}"
                    />
                  </div>
                </ion-item>

                <div class="validation-errors" *ngIf="tipo === '6'">
                  <ng-container
                    *ngFor="let validation of validation_messages.telCelular"
                  >
                    <div
                      class="error-message"
                      *ngIf="validations_form.get('telCelular')?.hasError(validation.type) && (validations_form.get('telCelular')?.dirty || validations_form.get('telCelular')?.touched)"
                    >
                      {{ validation.message }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container>
                <ion-item>
                  <ion-input
                    label-placement="stacked"
                    placeholder="{{'E-mail' | translate}}"
                    type="email"
                    [email]="validations_form.get('email')?.value!==''"
                    formControlName="email"
                  >
                    <div slot="label" class="slot-label">
                      {{'Digite seu E-mail' | translate}}<ion-text
                        class="danger"
                        color="danger"
                        *ngIf="tipo === '6'"
                        >*</ion-text
                      >
                    </div>
                  </ion-input>
                </ion-item>

                <div class="validation-errors" *ngIf="tipo === '6'">
                  <ng-container
                    *ngFor="let validation of validation_messages.email"
                  >
                    <div
                      class="error-message"
                      *ngIf="validations_form.get('email')?.hasError(validation.type) && (validations_form.get('email')?.dirty || validations_form.get('email')?.touched)"
                    >
                      {{ validation.message }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ion-list>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div class="down">
        <ion-button
          expand="block"
          class="btn-success"
          *ngIf="tipo === '6'"
          (click)="salvarTodos()"
        >
          {{'salvar' | translate}}
        </ion-button>

        <ion-button
          expand="block"
          class="btn-success"
          *ngIf="tipo === '1'"
          (click)="salvar()"
        >
          {{'Salvar' | translate}}
        </ion-button>

        <ion-button
          expand="block"
          class="btn-success"
          *ngIf="tipo != '1' && tipo != '0'"
          (click)="salvar()"
        >
          {{'Salvar' | translate}}
        </ion-button>
      </div>
    </form>
  </div>
</ion-content>
